import Vue from 'vue'
import Router from 'vue-router'
import HomePageV2 from '../components/HomePageV2'
import Login from '../components/Login'
import VueCookie from 'vue-cookie'
import IntuitLogin from '../components/accounting/IntuitLogin'
import RouterGuard from './_RouterGuards'
import jobBoard from './jobBoard'
import store from '../store'
import socialMedia from './socialMedia'
import boardOfDirectors from './boardOfDirectors'
import LinkedInCompanyAuthorization from '../components/tools/LinkedInCompanyAuthorization'
import organizations from './organizations'
import activities from './activities'
import maaStarts from './maaStarts'
import communications from './communications'
import startupResources from './startupResources'

Vue.use(VueCookie)
Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: HomePageV2,
      beforeEnter: function (to, from, next) {
        return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/intuit-login',
      name: 'Intuit Login',
      component: IntuitLogin,
      beforeEnter: function (to, from, next) {
        return RouterGuard.isAccountType(to, from, next, store.getters.hasAdministrator)
      }
    },
    {
      path: '/oauth-authorization',
      name: 'OAuth Authorization',
      component: LinkedInCompanyAuthorization,
      beforeEnter: function (to, from, next) {
        return RouterGuard.isAccountType(to, from, next, store.getters.hasAdministrator)
      }
    },
    //  Activities
    activities.activities, activities.createAnActivity, activities.printableOrganizationActivities,
    activities.printableActivities, activities.singleActivity,
    //  Job Board
    jobBoard.jobBoardIndex, jobBoard.jobBoardMetrics, jobBoard.jobPost,
    //  Board of Directors
    boardOfDirectors.boardOfDirectorsIndex,
    //  Social Media
    socialMedia.mailchimpAssigner, socialMedia.externalMediaAssigner,
    //  Organizations
    organizations.organizationRankings, organizations.organizationsSearch, organizations.embeddedReports,
    //  MAA STARTS
    maaStarts.maaStartsHome, maaStarts.maaStartsHomeV3,
    //  Communications
    communications.externalMediaAssigner, communications.wordpressTagAssigner,
    startupResources.startupResourcesIndex
  ]
})

router.beforeEach((to, from, next) => {
  if ('isPublic' in to.meta && to.meta.isPublic) {
    //  do not show nav bar to public facing pages
    store.commit('setNavigationBarVisibility', false)
  } else if (!store.getters.isAuthenticated) {
    //  check authentication on every non-public route change.
    next({path: '/login', params: { nextUrl: to.fullPath }})
  } else {
    //  page is not public and the user is logged in. Allow through.
    store.commit('setNavigationBarVisibility', true)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js